import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import {
  Badge,
  Card,
  CardHeader,
  Media,
  Spinner,
  Table,
  UncontrolledTooltip,
} from 'reactstrap'
import { setManagersOverviewFetched } from 'store/Dashboard/actions'
import { setManagersOverview } from 'store/Dashboard/actions'
import AxiosInstance from 'utils/AxiosInstance'
import Loader from 'views/pages/Loader'

function ManagersOverview() {
  const dispatch = useDispatch()

  const {
    managersOverviewFetched,
    managersOverview: { managersLoading, managersOverview },
  } = useSelector((state) => state.dashboard)

  let completed
  let pending
  let noActivity

  const fetchUsersByStores = () => {
    dispatch(setManagersOverview({ managersLoading: true }))
    AxiosInstance.get('/users/store-users').then((data) => {
      dispatch(setManagersOverview({ managersOverview: data }))
      dispatch(setManagersOverview({ managersLoading: false }))
      dispatch(setManagersOverviewFetched(true))
    })
  }

  useEffect(() => {
    if (managersOverviewFetched) return
    fetchUsersByStores()
  }, [managersOverviewFetched])

  return (
    <Card className='h-100'>
      <CardHeader className='border-0'>
        <h3 className='mb-0'>Managers Overview</h3>
      </CardHeader>
      <div className='table-responsive h-100 scrollbar'>
        <Table className='align-items-start table-flush'>
          <thead className='thead-light'>
            <tr>
              <th scope='col'>Name</th>
              <th scope='col'>Locations</th>
              {/* <th scope='col'>Users</th> */}
              <th scope='col'>Progress</th>
            </tr>
          </thead>

          <tbody className='list'>
            {managersLoading ? (
              <td className='text-center h1' colSpan={2}>
                <Loader color='primary' />
              </td>
            ) : (
              managersOverview?.length > 0 &&
              managersOverview.map((manager, index) => (
                <tr key={index}>
                  <th scope='row'>
                    <Media className='align-items-center'>
                      <Media>
                        <span className='name mb-0 text-sm'>
                          {manager.first_name} {manager.last_name}
                        </span>
                      </Media>
                    </Media>
                  </th>
                  <td className='budget'>
                    {/* {manager.location_names.split(',').join(', ')} */}
                    {manager.location_names.split(',')[0]}
                  </td>

                  {/* <td>
                    <div className='avatar-group'>
                      {manager.users.length > 0 &&
                        manager.users[0].slice(0, 5).map((user) => (
                          <a
                            className='avatar avatar-sm rounded-circle'
                            href='#pablo'
                            id={`tooltip-${user.id + manager.id}`}
                            onClick={(e) => e.preventDefault()}
                          >
                            <img
                              alt='...'
                              style={{
                                objectFit: 'cover',
                                height: '100%',
                              }}
                              src={
                                user.avatar
                                  ? JSON.parse(user.avatar).url
                                  : '/static/media/default_avatar.3cb2b636.png'
                              }
                            />
                            <UncontrolledTooltip
                              delay={0}
                              target={`tooltip-${user.id + manager.id}`}
                            >
                              {user.first_name} {user.last_name}
                            </UncontrolledTooltip>
                          </a>
                        ))}
                    </div>
                  </td> */}
                  <td>
                    <Badge
                      className='badge-dot mr-4'
                      id={`tooltip-pending${manager.id}`}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className='bg-warning' />
                      <span className='status'>
                        {
                          (pending = manager.users[0].reduce((total, item) => {
                            return total + (item.status === 3 ? 1 : 0)
                          }, 0))
                        }
                      </span>
                      <UncontrolledTooltip
                        delay={0}
                        target={`tooltip-pending${manager.id}`}
                      >
                        {pending + ' Pending'}
                      </UncontrolledTooltip>
                    </Badge>
                    <Badge
                      className='badge-dot mr-4'
                      id={`tooltip-completed${manager.id}`}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className='bg-primary' />
                      <span className='status'>
                        {
                          (completed = manager.users[0].reduce(
                            (total, item) => {
                              return total + (item.status == 4 ? 1 : 0)
                            },
                            0
                          ))
                        }
                      </span>
                      <UncontrolledTooltip
                        delay={0}
                        target={`tooltip-completed${manager.id}`}
                      >
                        {completed + ' Completed'}
                      </UncontrolledTooltip>
                    </Badge>
                    <Badge
                      className='badge-dot mr-4'
                      id={`tooltip-noactivity${manager.id}`}
                      style={{ cursor: 'pointer' }}
                    >
                      <i className='bg-light' />
                      <span className='status'>
                        {
                          (noActivity = manager.users[0].reduce(
                            (total, item) => {
                              return total + (item.status === 0 ? 1 : 0)
                            },
                            0
                          ))
                        }
                      </span>
                      <UncontrolledTooltip
                        delay={0}
                        target={`tooltip-noactivity${manager.id}`}
                      >
                        {noActivity + ' No Activity'}
                      </UncontrolledTooltip>
                    </Badge>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </Card>
  )
}

export default ManagersOverview
